import { cardItems } from '@/mocks/home';

export default function Cards() {
  return (
    <section id="cards" className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1024px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2">
          精选推荐
        </h2>
        <p className="text-sm text-foreground-600 mb-6 md:mb-8">高分好评漫画精选，每一部都值得一看</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cardItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-100 rounded-lg overflow-hidden border border-background-200/70 group cursor-pointer"
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
                <span className="absolute top-3 right-3 px-2 py-0.5 text-xs font-bold rounded bg-primary-500 text-background-50 whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-3 md:p-4">
                <p className="text-xs text-accent-600 font-medium mb-1">{item.subtitle}</p>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1.5">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}